import React from 'react';

import { LoadingIndicator } from '@petsmart-ui/sparky';
import '@app/plp/components/LoadingOverlay/LoadingOverlay.scss';

export type LoadingOverlayProps = {
    show?: boolean;
};

export default function LoadingOverlay({
    show,
}: Readonly<LoadingOverlayProps>) {
    return show ? (
        <div className="overlay" data-testid="loading-overlay">
            <LoadingIndicator iconSize="4xl" />
        </div>
    ) : null;
}
